/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx, css } from "@emotion/react";
import { useNavigate } from "react-router-dom";
import { useState, useEffect, useContext } from "react";
import { Outfit as OutfitElement } from "../Outfit"; // OutfitElement is used since Outfit is a prop
import { NoItemCard } from "../../general/misc/NoItemCard";
import { AppContext } from "../../../contexts/App";

export const OutfitCard = ({
	outfit = null,
	nohover = false,
	onCardClick = null,
	cardType = "",
	individual = false,
	cardCheck = (Outfit) => false,
}) => {
	const navigate = useNavigate();
	const [appState, dispatch] = useContext(AppContext);

	const handleClick = (id) => {
		dispatch({
			type: "set_outfitRedirect",
			outfitRedirect: window.location.href.split("?")[1],
		});
		navigate(`/outfits/${id}`);
	};

	const [opacityState, setOpacityState] = useState(true);

	return !outfit ? (
		<NoItemCard />
	) : (
		<div
			className={`w-full h-full transition-border duration-75 border border-transparent ${
				nohover
					? ""
					: cardCheck(outfit)
					? "opacity-40 cursor-not-allowed"
					: "cursor-pointer sm:hover:border-gray-400"
			} py-4`}
		>
			<div
				onClick={
					nohover
						? null
						: onCardClick
						? () => onCardClick(outfit)
						: () => handleClick(outfit.outfit_id)
				}
				className={`flex flex-col w-full h-full select-none items-center`}
			>
				<div
					className={`flex w-full h-full transition-all duration-300 ${
						opacityState ? "opacity-100" : "opacity-0"
					} justify-center items-center mb-2`}
				>
					<OutfitElement
						type={cardType}
						individual={individual}
						outfit={outfit}
					/>
				</div>
				<div className="flex flex-col justify-end items-center px-4 mb-2 font-light text-center w-full">
					<span className="w-full truncate">
						{outfit.outfit_name != "" ? (
							outfit.outfit_name
						) : (
							<span>&nbsp;</span>
						)}
					</span>
					<span className="w-full truncate text-xs">
						${outfit.outfit_cost}
					</span>
				</div>
			</div>
		</div>
	);
};
